import './public.scss';
import '../shared/ebc-datepicker.scss';
import { initFlatpickr } from '../shared/flatpickr-init';

jQuery(document).ready(function () {
	const { options, booked_dates } = devnet_ebc_script_data;

	const bookedDates = booked_dates ? booked_dates : [];

	const isOpen = options.open == 1;
	const clientDateFormat = options.date_format || 'F j, Y';
	const locale = options.locale || 'en';

	const availabilityMode = options.availability_mode;
	const rawDates = options.dates || '';
	const adminDateList = rawDates
		.split(',')
		.map((d) => d.trim())
		.filter(Boolean);

	const maxDate = getDaysFromLimit(options.max_date_limit);

	const flatpickrConfig = {
		isOpen,
		locale,
		clientDateFormat,
		onChange(selectedDates) {
			const dateStart = new Date(selectedDates[0]);
			const dateEnd = new Date(selectedDates[1]);
			const timeDiff = dateEnd.getTime() - dateStart.getTime();
			let days = Math.floor(timeDiff / (1000 * 3600 * 24));
			days = days || 1;

			const $quantityField = jQuery('input[name="quantity"]');
			$quantityField.val(days).trigger('change').prop('disabled', true);
		},
	};

	flatpickrConfig.set = {};

	if (maxDate) {
		flatpickrConfig.set.maxDate = new Date().fp_incr(maxDate);
	}

	// Apply availability logic
	if (availabilityMode === 'disable_selected') {
		flatpickrConfig.set.disable = [...adminDateList, ...bookedDates];
	} else if (availabilityMode === 'allow_selected') {
		flatpickrConfig.set.enable = adminDateList;
		flatpickrConfig.set.disable = bookedDates; // always disable booked
	} else {
		// Default: no admin restrictions, only block booked dates
		flatpickrConfig.set.disable = bookedDates;
	}

	initFlatpickr('#ebc-date-field', flatpickrConfig);

	function getDaysFromLimit(limitKey) {
		if (!limitKey || typeof limitKey !== 'string') {
			return null;
		}

		const value = parseInt(limitKey.match(/\d+/)?.[0], 10);
		if (isNaN(value)) {
			return null;
		}

		const now = new Date();
		const future = new Date(now); // clone current date

		if (limitKey.endsWith('d')) {
			future.setDate(future.getDate() + value);
		} else if (limitKey.endsWith('m')) {
			future.setMonth(future.getMonth() + value);
		} else if (limitKey.endsWith('y')) {
			future.setFullYear(future.getFullYear() + value);
		} else {
			return null;
		}

		// Calculate the number of days between now and the future date
		const msPerDay = 1000 * 60 * 60 * 24;
		const timeDiff = future.getTime() - now.getTime();

		return Math.round(timeDiff / msPerDay);
	}
});
